// Moglee Base — predictive search overlay.
// Opens from any search link in the header, queries Shopify's suggest endpoint,
// and lists products as the visitor types.

(function () {
  var overlay = document.querySelector('[data-mb-psearch]');
  if (!overlay) return;

  var input = overlay.querySelector('[data-mb-psearch-input]');
  var body = overlay.querySelector('[data-mb-psearch-body]');
  var limit = parseInt(overlay.getAttribute('data-limit'), 10) || 6;
  var timer = null;
  var controller = null;
  var lastFocus = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function open(event) {
    if (event) event.preventDefault();
    lastFocus = document.activeElement;
    overlay.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    window.setTimeout(function () {
      input.focus();
    }, 30);
  }

  function close() {
    overlay.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function render(products, term) {
    if (products.length === 0) {
      body.innerHTML =
        '<p class="mb-psearch__empty">Nothing matched “' + escapeHtml(term) + '”.</p>';
      return;
    }

    var items = products
      .map(function (product) {
        var image = product.featured_image && product.featured_image.url;
        return (
          '<li><a class="mb-presult" href="' +
          product.url +
          '">' +
          '<span>' +
          (image ? '<img src="' + image + '&width=140" alt="" loading="lazy">' : '') +
          '</span>' +
          '<span><p class="mb-presult__title">' +
          escapeHtml(product.title) +
          '</p></span>' +
          '<span class="mb-presult__price">' +
          (product.price ? product.price : '') +
          '</span>' +
          '</a></li>'
        );
      })
      .join('');

    body.innerHTML =
      '<ul class="mb-psearch__list">' +
      items +
      '</ul><a class="mb-psearch__all mb-accent" href="' +
      root() +
      'search?q=' +
      encodeURIComponent(term) +
      '">See all results</a>';
  }

  function search(term) {
    if (controller) controller.abort();
    controller = new AbortController();

    var url =
      root() +
      'search/suggest.json?q=' +
      encodeURIComponent(term) +
      '&resources[type]=product&resources[limit]=' +
      limit +
      '&resources[options][unavailable_products]=last';

    fetch(url, { signal: controller.signal })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        render(products, term);
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        body.innerHTML = '<p class="mb-psearch__empty">Search is unavailable right now.</p>';
      });
  }

  input.addEventListener('input', function () {
    var term = input.value.trim();
    window.clearTimeout(timer);

    if (term.length < 2) {
      body.innerHTML = '<p class="mb-psearch__hint">Type at least two letters.</p>';
      return;
    }

    timer = window.setTimeout(function () {
      search(term);
    }, 220);
  });

  // Any header link pointing at the search page opens the overlay instead.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('header a[href*="/search"], [data-mb-search-toggle]');
    if (link) {
      open(event);
      return;
    }
    if (event.target.closest('[data-mb-psearch-close]')) close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && overlay.getAttribute('data-open') === 'true') close();
  });
})();
